<template>
  <div>
    <div class="mb-1">
      <a
        class="btn btn-danger"
        @click="history"
      >
        <feather-icon icon="CornerUpLeftIcon" />Trở lại
      </a>
    </div>
    <div class="card">
      <div class="card-body">
        <div v-html="htmlContent" />
      </div>

    </div>
  </div>
</template>
<script>

import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BFormCheckbox,
  BBadge, BDropdown, BDropdownItem, BPagination, BInputGroupAppend, BInputGroup, BFormRadio,
} from 'bootstrap-vue'
import {
  ref, watch, computed, onMounted,
} from '@vue/composition-api'
import store from '@/store'
import { useRouter } from '@core/utils/utils';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import moment from 'moment'

export default {
  components: {
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroupAppend,
    AppBreadcrumb,
    BInputGroup,
    BFormCheckbox,
  },
  setup() {
    const { route, router } = useRouter();
    const htmlContent = ref('');
    const article_id = route.value.params.id !== undefined ? route.value.params.id : 0;
    const first_id = route.value.params.first_id != undefined ? route.value.params.first_id : 0;
    const last_id = route.value.params.last_id != undefined ? route.value.params.last_id : 0;
    const fetchData = () => {
      store.dispatch('article/articleDiff', { article_id, first_id, last_id })
        .then(response => {
          const result = response.data;
          if (result.code === 200) {
            htmlContent.value = result.data;
          } else {
            // thong bao loi
          }
        })
    }
    fetchData();

    return {
      htmlContent,
    }
  },
  methods: {
    format_datetime(value) {
      return moment.unix(value).format('YYYY/MM/DD - HH:mm')
    },
    history() {
      const article_id = this.$route.params.id;
      this.$router.push({ name: 'article-history', params: { id: article_id } });
    },
  },
}
</script>

<style lang="scss">
.statusText {
  padding: 0.4rem;
  font-size: 0.9rem
}

.note {
  width: 20%;
}

@import '@core/scss/vue/libs/vue-select.scss';
</style>
